import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import CookieConsent from "./CookieConsent";
import { getConsent, trackPageView } from "@/lib/googleAnalytics";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const AnalyticsPageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (getConsent() === "all") {
      trackPageView(`${location.pathname}${location.search}`);
    }
  }, [location.pathname, location.search]);

  return null;
};

const Layout = ({ children }: { children: React.ReactNode }) => (
  <div className="min-h-screen flex flex-col">
    <ScrollToTop />
    <AnalyticsPageTracker />
    <Navbar />
    <main className="flex-1">{children}</main>
    <Footer />
    <CookieConsent />
  </div>
);

export default Layout;

